import React, { useEffect,useState } from "react";
import Navbar from "../components/Navbar";
import Top from "../components/Top";
import WWD from "../components/WWD";
import OTTProducts from "../components/OTTProducts";
import StartWithUs from "../components/StartWithUs";
import Clients from "../components/Clients";
import Contact from "../components/Contact";
import Careers from "../components/Careers";
import Footer from "../components/Footer";
import Navigator from "../components/Navigator";
import { Carousel } from "../components/Carousel/Carousel1/Carousel";
import { slides } from "../components/Carousel/Carousel1/data";
import imag from "../assets/Vivre.png";
import "../components/Carousel/Carousel1/Carousel";
import FrontendApp from "./OttFrontend";
import Services from "./PlatformSupportServices";
import PlatformSupported from "./platformSupport/platforms";
import Card from "../components/Card/card";
import Banner from "../components/Banner";
import { Typography, Box } from "@mui/material";
import OttPartners from "./partners";
import MiniCarousel from "../components/MiniCarousel";
import WhoWeAre from "./AboutUs/WhoWeAre";
import NewFooter from "../components/NewFooter/NewFooter";
import HeroBanner from "../components/HeroBanner/Herobanner";
import InfiniteLogoCarousel from "../components/horizontalLogoCarousel/logoCarousel";
import "./Home.css";
import AOS from "aos";
import "aos/dist/aos.css";
import { useNavigate } from "react-router";
import { PopupModal } from "react-calendly";

export default function Home() {
  const navigate = useNavigate();
    const [open, setOpen] = useState(false);

  const Products = [
    {
      src: require("../assets/Home/cropped-Vivre.png"),
      href: "/Vivre",
      title: "The Experience Platform",
    },
    {
      src: require("../assets/Home/cropped-sara2.png"),
      href: "/Sara",
      title: "Enrich Your Experience",
    },
    {
      src: require("../assets/Home/Hospitality.png"),
      href: "/Hospitility",
      title: "Horizon Hospitility Hub",
    },
    {
      src: require("../assets/Home/cropped-Blinks.png"),
      href: "/Blink",
      title: "User Generated Content",
    },
  ];

  const Partners = [
    {
      src: `${require("../assets/Home/Handshake2.png.jpg")}`,
      href: "/Kaltura",
    },
  ];

  const Customers = [
    {
      src: `${require("../assets/Home/cropped-Astro_logo.png")}`,
      href: "/Astro",
    },
    {
      src: `${require("../assets/Home/cropped-Dialog_Axiata_logo.png")}`,
      href: "/Dialog",
    },
    {
      src: `${require("../assets/Home/cropped-dish_logo.webp")}`,
      href: "/DishTv",
    },
    {
      src: `${require("../assets/Home/cropped-Emeritus_Logo.jpeg")}`,
      href: "/Emiratus",
    },
    {
      src: `${require("../assets/Home/cropped-Reshet_13.png")}`,
      href: "/Reshet",
    },
  ];

  useEffect(() => {
    AOS.init({
      duration: 1000, // Animation duration in ms
      once: false, // Whether animation should happen only once
      offset: 150, // Offset (in px) from the original trigger point
    });
  }, []);

  useEffect(() => {
    let x = document.getElementById("wwd");
    let y = document.getElementById("contact");

    if (window.location.hash === "#wwd") x.scrollIntoView();
    else if (window.location.hash === "#ott-products")
      document.getElementById("ott-products").scrollIntoView();
    else if (window.location.hash === "#swu")
      document.getElementById("swu").scrollIntoView();
    else if (window.location.hash === "#contact")
      setTimeout(() => {
        y.scrollIntoView();
      }, 500);
  }, []);

  return (
    <div
      style={{
        background: "black",
        overflow: "hidden",
      }}
      className="main-container"
    >
      <div className="inner-container">
        <div className="hero-banner">
          <HeroBanner />
        </div>

        <div className="partners-section1">
          <Typography
            data-aos="zoom-in"
            style={{
              display: "flex",
              justifyContent: "center",
              fontSize: "39px",
              fontWeight: "800",
              fontFamily: "system-ui",
              color: "#6054E4",
             
            }}
          >
            Our Partners
          </Typography>

          <div data-aos="zoom-in" className="logo-carousel-wrapper">
            <InfiniteLogoCarousel />
          </div>

          {/* <div
            data-aos="zoom-in"
            style={{
              width: "80vw",
              marginLeft: "10vw",
              padding: "0",
              marginBottom: "40px",
            }}
            className="ibc-banner"
          >
            <video
              src="https://horizon-vivre-images-dev.s3.ap-south-1.amazonaws.com/WebsiteVideo/ibcFinal.mp4"
              alt="IBC Logo"
              muted
              autoPlay
              playsInline
              loop
            ></video>
            <button
            className="bookMeetingBtn"
              onClick={() => setOpen(true)}
            >
              Book a Meeting
            </button>
             <PopupModal
        url="https://calendly.com/d/cr6t-c2w-c48/book-your-meeting-with-us"
        onModalClose={() => setOpen(false)}
        open={open}
        rootElement={document.getElementById("root")}
      />
          </div> */}
        </div>

        <div className="footer-section">
          <NewFooter />
        </div>
      </div>
    </div>
  );
}
